import { render, staticRenderFns } from "./LoadForm.vue?vue&type=template&id=2a81dc50"
import script from "./LoadForm.vue?vue&type=script&lang=js"
export * from "./LoadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports